interface WaveDividerProps {
  topColor: string;
  bottomColor: string;
  flip?: boolean;
}

export default function WaveDivider({
  topColor,
  bottomColor,
  flip = false
}: WaveDividerProps) {
  return (
    <div
      className={`relative w-full ${flip ? "rotate-180" : ""} -mt-1 h-10 md:h-20`}
      style={{ backgroundColor: topColor }}
    >
      {/* Desktop wave - dramatic */}
      <svg
        className="hidden md:block absolute bottom-0 w-full h-full"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1440" height="80" fill={topColor} />
        <path
          d="M0,40 C240,10 360,25 480,40 C600,55 720,65 840,55 C960,45 1080,25 1200,35 C1320,45 1380,50 1440,45 L1440,80 L0,80 Z"
          fill={bottomColor}
        />
      </svg>

      {/* Mobile wave - subtle */}
      <svg
        className="md:hidden absolute bottom-0 w-full h-full"
        viewBox="0 0 1440 40"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1440" height="40" fill={topColor} />
        <path
          d="M0,25 C360,18 480,22 720,25 C960,28 1080,22 1440,25 L1440,40 L0,40 Z"
          fill={bottomColor}
        />
      </svg>
    </div>
  );
}
